import React, { useState, useEffect } from 'react';
import { OptionalState } from '../../utils/ReactHelper';
import Logger from '../../../common/utils/Logger';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

import '../css/Login.css';
import AuthLogin from './AuthLogin';
import AuthSignUp from './AuthSignUp';
import Linker from '../../library/Linker';
import { PagePath } from '../PagePath';

type Props = {
    linker: Linker;
    path: string;
};

type State = {
};

const StateDefault: State = {
};

const Auth = (props: Props) => {

    const [state, setState] = useState(StateDefault);

    const updateState = (updates: Partial<State>) => {
        setState(OptionalState(state, updates));
    };

    useEffect(() => {
        new Promise(async (resolve, reject) => {
            return Promise.resolve();
        });
    }, []);

    return (
        <>
            <Container className='login-container'>
                <Tabs
                    defaultActiveKey={props.path}
                    id="fill-tab-example"
                    className="mb-3 rounded-pill"
                    fill
                >
                    <Tab eventKey={PagePath.AuthLogin} title="Login" className="rounded-pill">
                        <AuthLogin linker={props.linker}></AuthLogin>
                    </Tab>
                    <Tab eventKey={PagePath.AuthSignUp} title="Sign Up" className="rounded-pill">
                        <AuthSignUp linker={props.linker}></AuthSignUp>
                    </Tab>
                </Tabs>
            </Container>
        </>
    );
};

export default Auth;